module.exports = __webpack_public_path__ + "img/question_box.87a847b0.svg";